// Master switch for phone field mode. While true, the phone-sized WEBSITE
// (width under 768px) is pared down to what a scout does in the field:
// make observations of the community, and walk the home-hardening checklist
// for their own property. The tab bar keeps Property, Community and "+";
// News, Funding and Guidance leave it. The Guidance overlay, the map's
// Layers button, "Share news", the structure page's plan suggestions and
// the plan-editing controls in the shared plan viewer are hidden too.
// Why: Glenn asked for it on Oct 8 2026. Nothing is deleted and no route is
// blocked: /feed, /funding and the rest still load from a direct link.
// Tablet web, the desktop shell and the native apps are not affected.
//
// Revert: flip this const to false to restore the full phone layout.
// `grep -rn useFieldMode` lists every gate site.
export const FIELD_MODE_ON_PHONE = true;
